<template>
  <b-modal
    :id="id"
    :ref="id"
    :title="title | i18n"
    :ok-title="isScreenshotForFileUpload ? $translate('upload') : $translate('Paste in chat content')"
    :cancel-title="'remove' | i18n"
    ok-variant="primary"
    cancel-variant="outline-danger"
    button-size="lg"
    size="lg"
    centered
    content-class="rounded-8"
    @ok="save"
    @hide="clear"
    @shown="shownModal"
  >
    <div>
      <div class="settings-box">
        <Select
          v-model="line"
          form-group-id="lineWidth"
          placeholder="Line thickness"
          :options="lineWidthOptions"
          class="select"
        />
        <div class="d-flex flex-column">
          <label class="color-label" for="line_color">
            {{ 'Line color' | i18n }}
          </label>
          <input
            id="line_color"
            v-model="color"
            type="color"
            style="height: 45px; margin-top: 1px;"
          >
        </div>
        <div class="pt-1 ml-auto">
          <b-button
            size="lg"
            class="mt-4"
            variant="outline-primary"
            @click.prevent="$refs.VueCanvasDrawing.reset()"
          >
            {{ 'Undo drawing' | i18n }}
          </b-button>
        </div>
      </div>
      <VueDrawingCanvas
        ref="VueCanvasDrawing"
        class="canvas-box"
        :width="750"
        :height="500"
        :image.sync="image"
        :background-image="screenshot"
        :lineWidth="line"
        :stroke-type="strokeType"
        :color="color"
        line-cap="square"
        line-join="miter"
        :eraser="false"
        :disabled="false"
        :fillShape="false"
      />
    </div>
  </b-modal>
</template>

<script>
import VueDrawingCanvas from 'vue-drawing-canvas';
import Select from '../../../../../common/select';
import { NotificationMixin, FirebaseMixinOne, AuthMixin } from '../../../../../../../mixins';

export default {
  name: 'EditScreenshot',
  components: { VueDrawingCanvas, Select },
  mixins: [NotificationMixin, FirebaseMixinOne, AuthMixin],
  props: {
    id: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    screenshot: {
      type: String,
      default: null,
    },
    hash: {
      type: String,
      default: () => '',
    },
    setFieldValue: {
      type: Function,
      default: () => {},
    },
    screenshotField: {
      type: Object,
      default: () => {},
    }
  },
  data: function () {
    return {
      image: '',
      line: 5,
      color: '#000000',
      strokeType: 'dash',
      lineWidthOptions: [],
    };
  },
  computed: {
    isScreenshotForFileUpload: function () {
      return this.id === 'send-screenshot-to-file-field';
    },
  },
  created() {
    const arr = [...Array(31).keys()];
    arr.shift();
    this.lineWidthOptions = arr.map((number) => ({ value: number, text: number }));
  },
  methods: {
    shownModal() {
      this.$refs.VueCanvasDrawing.reset();
    },
    clear() {
      this.line = 5;
      this.color = '#000000';
    },
    async save() {
      const uniqID = Math.random().toString(16).slice(2);
      if (this.isScreenshotForFileUpload) {
        try {
          const imgBlob = await fetch(this.image).then(r => r.blob());
          const file = new File([imgBlob], `${uniqID}_screenshot.png`, { type: 'image/png', lastModified: new Date() });
          await this.setFieldValue(this.screenshotField, file);
        } catch (error) {
          this.showNotification({ type: 'error', message: error.message });
        }
      } else {
        try {
          await this.firebaseServiceOne.initFirebase();
          const imgBlob = await fetch(this.image).then(r => r.blob());
          if (!imgBlob) throw new Error(this.$translate('turned_off_camera'));
          
          const message = {
            message: `${uniqID}_screenshot.png`,
            contentType: imgBlob.type,
            userId: this.auth.id,
            userName: this.auth.email,
          };
          const ref = { progress: 0, isUploading: true };

          await this.firebaseServiceOne.uploadFile({ hash: this.hash, file: imgBlob, uniqID, ref, message });
          this.showNotification({ type: 'success', message: this.$translate('success_send_screenshot') });
        } catch (error) {
          this.showNotification({ type: 'error', message: error.message });
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">

.canvas-box {
  width: 100%;
  height: auto;
}

.settings-box {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  margin-bottom: -25px;

  .select {
    width: 25%;
  }
}

.color-label {
  font-size: 16px;
  line-height: 20px;
}

::v-deep .modal-header {
  border: none;
  padding-bottom: 0px!important;
}

::v-deep .modal-footer {
  justify-content: space-between;
  padding: 1.5rem;
  padding-top: 0;
  border: none;
  & > button {
    padding-right: 100px;
    padding-left: 100px;
    margin: 0;
  }
}

::v-deep .rounded-8 {
  border-radius: 8px;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}

</style>